import { render, staticRenderFns } from "./timeLimited.vue?vue&type=template&id=2300de7a&scoped=true&"
import script from "./timeLimited.vue?vue&type=script&lang=js&"
export * from "./timeLimited.vue?vue&type=script&lang=js&"
import style0 from "./timeLimited.vue?vue&type=style&index=0&id=2300de7a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2300de7a",
  null
  
)

export default component.exports